import Cookies from "./../library/Cookies";
import Forms from "./Forms";

export default class Popups {
	constructor() {
		this.instance = self;
		this.popupOptions = {
			removalDelay: 500,
	        closeOnBgClick : true,
	        mainClass: 'mfp-slide-out',
	        callbacks: {
				open: function() {
					$('body').addClass('popup-open');
				},
                ajaxContentAdded: function() {
                    Forms.setResolutionInputs();
                },
				close: function() {
					$('body').removeClass('popup-open');
                    Cookies.deleteCookie("popupUrl");
				},
			}
		};
	}

	static init() {
		const self = new Popups;
		self.attachEvents();
	}

	attachEvents() {
		const self = this;

        // ensure popupUrl isn't set on page load as we have no popup open
		Cookies.deleteCookie("popupUrl");

		window.site.openCookiePopup = function (url) {
			self.openCookiePopup(url);
		};

		$(document).on("pageLoad", function () {
			// ensure popupUrl isn't set on page load as we have no popup open
			Cookies.deleteCookie("popupUrl");
		});

		self.initiateGallery('.js-gallery-popup');

		$(document).on('click', '.js-popup', function(e){
	        e.preventDefault();
	        self.openAjaxPopup($(this).attr('href'));
	    });

		$(document).on('click', '.js-popup-inline', function (e) {
            e.preventDefault();
            self.openInlinePopup($(this).attr('href'));
        })

	    $(document).ready(function() {
		    $('.js-popup-iframe').magnificPopup({
		        type: 'iframe',
		        mainClass: 'mfp-fade',
		        preloader: true,
		    });
		});
	}

	initiateGallery(selector) {
		const self = this;
		self.openGalleryPopup($(selector), selector);
	}

	openAjaxPopup(url) {
        const self = this;

        self.openPopup({
            items: { src: url },
            type: 'ajax',
            mainClass: 'mfp-slide-out'
        });
    }

	openInlinePopup(id) {
        const self = this;

        self.openPopup({
            items: {
                src: id
            },
            type: 'inline',
            mainClass: 'mfp-slide-out'
        });
    }

	openPopup(options) {
        const self = this;

        var magnificPopup = $.magnificPopup.instance,
            defaultOptions = self.popupOptions,
            popupOptions = Object.assign(defaultOptions, options);


        if (popupOptions.type == "ajax") {
			popupOptions.callbacks.ajaxContentAdded = function () {
				Forms.setResolutionInputs();

				$(document).trigger("popupOpen", popupOptions.items.src);

				Cookies.setCookie("popupUrl", popupOptions.items.src, 1);

				if (popupOptions.target == "cookie-popup") {
					// If cookie bar popup - trigger a change on all performance checkboxes - easier to manage this way
					$("#cookies-performance-all").prop("checked", true).trigger("change");
				}
			};

			// If cookie popup is opened - amend close function callback
			if (popupOptions.target == "cookie-popup") {
				popupOptions.callbacks.close = function () {
					$("body").removeClass("popup-open");
				};
			}
		} else if (popupOptions.type == "inline") {
			popupOptions.callbacks.elementParse = function (item) {
				$(document).trigger("popupOpen", popupOptions.items.src);
			};
		}

        if (magnificPopup.isOpen == true) {
            magnificPopup.close();

            setTimeout(function () {
                $.magnificPopup.open(popupOptions);
            }, 500);
        } else {
            $.magnificPopup.open(popupOptions);
        }
    }


	openIframePopup(id) {
		$element.magnificPopup({
			type: 'iframe',
			delegate: 'a',
            mainClass: 'mfp-zoom-out',
		});
	}

	openGalleryPopup($element, selector) {
		var isInstagram = $element.hasClass('js-instagram-gallery');

		$element.magnificPopup({
            type: 'image',
            delegate: 'a',
            mainClass: 'mfp-zoom-out',
            fixedContentPos: true,
            gallery: {
                enabled:true
            },
            image: {
                titleSrc: function(item) {
                    if (isInstagram) return '';
                    return item.el.find('img').data('caption') || '';
                },
                tError: '<a href="%url%">The image #%curr%</a> could not be loaded.'
            },

        callbacks: {
	        buildControls: function() {
	            if(this.arrowLeft)
	                this.arrowLeft.appendTo(this.contentContainer);
	            if(this.arrowRight)
	                this.arrowRight.appendTo(this.contentContainer);
	        },
          elementParse: function(item) {
            // Function will fire for each target element
            // "item.el" is a target DOM element (if present)
            // "item.src" is a source that you may modify
            
            if((item.el[0].className).includes('video')) {
              item.type = 'iframe',
              item.iframe = {
                 patterns: {
                   youtube: {
                     index: 'youtube.com/', // String that detects type of video (in this case YouTube). Simply via url.indexOf(index).

                     id: 'v=', // String that splits URL in a two parts, second part should be %id%
                      // Or null - full URL will be returned
                      // Or a function that should return %id%, for example:
                      // id: function(url) { return 'parsed id'; } 

                     src: '//www.youtube.com/embed/%id%' // URL that will be set as a source for iframe. 
                   },
                   vimeo: {
                     index: 'vimeo.com/',
                     id: '/',
                     src: '//player.vimeo.com/video/%id%?autoplay=1'
                   }
                 }
              }
            } else {
               item.type = 'image',
               item.tLoading = 'Loading image #%curr%...',
               item.mainClass = 'mfp-img-mobile',
               item.image = {
                 tError: '<a href="%url%">The image #%curr%</a> could not be loaded.'
               }
            }

          }
        }
        });
	}

	openCookiePopup(url) {
		const self = this;

		self.openPopup({
			items: { src: url },
			type: "ajax",
			target: "cookie-popup",
			mainClass: "mfp-zoom-out",
			closeOnBgClick: false,
			showCloseBtn: false,
		});
	}

}